var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.unit && _vm.relatie !== null)?_c('relatie-units',{attrs:{"relatie":_vm.relatie,"relatie-id":_vm.relatieId}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }